module.exports = __webpack_public_path__ + "img/cooperate_26.e93995ba.png";